import { Navigate, Route, Routes } from 'react-router-dom';
import { Map } from './Map';

export const MapRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Map />} />
      <Route path="*" element={<Navigate to="." />} />
    </Routes>
  );
};
